const constvar = {
    api_url: "/api/",
    administrator:'/badministrator'
};
export default constvar;
export const BACKEND_REDIRECT = 'BACKEND_REDIRECT';
export const BACKEND_APP_LOAD = 'BACKEND_APP_LOAD';


